import { Preferences } from '@capacitor/preferences';

export class SecurityUtils {
  // Secure storage using Capacitor Preferences
  static async secureStore(key: string, value: string): Promise<void> {
    await Preferences.set({ key, value });
  }

  static async secureRetrieve(key: string): Promise<string | null> {
    const result = await Preferences.get({ key });
    return result.value;
  }

  static async secureRemove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }

  static async clearAll(...args: string[]): Promise<void> {
    await Promise.all(args.map(key => this.secureRemove(key)));
  }
}
